module.exports = __webpack_public_path__ + "media/images/icons/feedback-c8d60d2c5cc99248efa03be0aafcd992.svg";